import { validateURLDirect } from './formsUtilities';
const accessProvisions = [
    { name: "AccessibleBabyFacilities", label: `Accessible Baby Facilities` },
    { name: "AccessibleParking", label: `Accessible Parking` },
    { name: "AccessibleToilets", label: `Accessible Toilets` },
    { name: "AdaptedInformation", label: `Adapted Information` },
    { name: "AssistanceAnimals", label: `Assistance Animals` },
    { name: "AudioDescription", label: `Audio Description` },
    { name: "Captioning", label: `Captioned` },
    { name: "ChangingPlacesToilet", label: `Changing Places Toilet` },
    { name: "ChilledPerformance", label: `Chilled Performance` },
    { name: "DementiaFriendly", label: `Dementia Friendly` },
    { name: "HearingLoopsAndHeadsets", label: `Hearing Loops and Headsets` },
    { name: "MinimalWalkingDistances", label: `Minimal Walking Distances` },
    //{name:"NoContentWarnings",label:msg(`No Content Warnings`)},
    { name: "NoStrobeLightingHazeEffects", label: `No Strobe Lighting / Haze Effects` },
    { name: "QuietSpaces", label: `Quiet Spaces` },
    { name: "RelaxedPerformance", label: `Relaxed Performance` },
    { name: "SeatAccess", label: `Seat Access` },
    { name: "SensoryAdapted", label: `Sensory Adapted` },
    { name: "SignLanguage", label: `Sign Language` },
    { name: "StepFreeLevelAccess", label: `Step Free Level Access` },
    { name: "WheelchairAccessible", label: `Wheelchair Accessible` },
];
const eventTypes = [
    { name: "ArtAndExhibitions", label: `Art and Exhibitions` },
    { name: "Cabaret", label: `Cabaret` },
    { name: "Circus", label: `Circus` },
    { name: "Comedy", label: `Comedy` },
    { name: "CoursesAndWorkshops", label: `Courses and Workshops` },
    { name: "Craft", label: `Craft` },
    { name: "Dance", label: `Dance` },
    { name: "FamiliarisationTours", label: `Familiarisation Tours` },
    { name: "FamilyFriendly", label: `Family Friendly` },
    { name: "FilmCinema", label: `Film / Cinema` },
    { name: "Festival", label: `Festival` },
    { name: "ImmersiveAndVR", label: `Immersive and VR` },
    { name: "LiteratureAndPoetry", label: `Literature and Poetry` },
    { name: "Music", label: `Music` },
    { name: "Musical", label: `Musical` },
    { name: "Opera", label: `Opera` },
    { name: "Pantomime", label: `Pantomime` },
    { name: "TalksAndDebates", label: `Talks and Debates` },
    { name: "Theatre", label: `Theatre` },
    { name: "TouchTours", label: `Touch Tours` }
];
const languages = [
    { name: 'en', label: 'English' },
    { name: 'cy', label: 'Cymraeg' },
    // {name: 'ga', label: 'Gaeilge'},
    { name: 'gd', label: 'Gaelic' }
];
const processEventData = (_eventData, locations = [], allProvisions = []) => {
    let returnEventData;
    let eventData = _eventData?.hasOwnProperty('event_data') ? _eventData.event_data : _eventData;
    let instances = [];
    if (eventData?.hasOwnProperty('instances')) {
        instances = eventData.instances.map(instance => {
            let date = instance.start ? new Date(instance.start) : null;
            let endDate = instance.end ? new Date(instance.end) : null;
            // BEGINNING of new conditional to allow ceratin start date and end date scenarios
            const now = new Date(); // take back by seven days
            now.setDate(now.getDate() - 7);
            now.setHours(0, 0, 0, 0); // strip time
            const dateInPast = date ? new Date(date).setHours(0, 0, 0, 0) < now : false;
            const endDateInPast = endDate ? new Date(endDate).setHours(0, 0, 0, 0) < now : false;
            let allowOldDates = false;
            if (endDateInPast || (!endDate && dateInPast)) {
                return {}; //deal with empy object when rendered in allin-repeater
            }
            if (dateInPast) {
                allowOldDates = true;
            }
            // END of new conditional to allow ceratin start date and end date scenarios
            //---------------Prevent event instance start and end times from converting multiple times and adding more hours upon edit ------------------
            //let start_time = date ? date.toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit' }) : '';
            let start_time = instance.start ? instance.start.split('T')[1]?.substring(0, 5) : '';
            //let end_time = endDate ? endDate.toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit' }) : '';
            let end_time = instance.end ? instance.end.split('T')[1]?.substring(0, 5) : '';
            let start = date ? date.toISOString().split('T')[0] : '';
            let end = endDate ? endDate.toISOString().split('T')[0] : '';
            let bookingLink = instance.bookingLink ? instance.bookingLink : '';
            if (bookingLink) {
                bookingLink = validateURLDirect(bookingLink);
            }
            return {
                start: start,
                start_time: start_time,
                end: end,
                end_time: end_time,
                bookingLink: bookingLink,
                zoneId: instance.zone ? instance.zone.id : '',
                instance_id: instance.id,
                provisions: instance.provisions,
                allowOldDates: allowOldDates,
            };
        });
    }
    let formatValue = eventData?.format;
    // if(!formatValue){
    //     formatValue = 'InPerson'
    // }
    let isTouring = eventData?.location?.id && !locations.find(location => location.id === eventData?.location?.id);
    let locationIDValue = isTouring ? 'touring_location' : eventData?.location?.id;
    let touringLocationValue = isTouring ? eventData?.location?.id : null;
    if (!formatValue && !isTouring) {
        formatValue = 'InPerson';
    }
    if (isTouring && formatValue === "InPerson") {
        formatValue = 'Touring';
    }
    let locURL = eventData?.locationUrl ? validateURLDirect(eventData.locationUrl) : '';
    let eventURL = eventData?.eventUrl ? validateURLDirect(eventData.eventUrl) : '';
    returnEventData = [
        { name: 'name', type: 'text', title: `What is the name of your event?`, value: eventData?.name, 'required': true, description: ``, error_message: `Please enter the name of your event` },
        { name: 'language', type: 'select', title: `What language will you be submitting this event in?`, value: eventData?.language || 'en', options: languages, description: `You can create multiple events in different languages which will appear on the translated listings pages.`, error_message: `Please select the primary language of your event` },
        { name: 'locationId', type: 'select', title: `Which location is this event held at?`, value: locationIDValue, 'required': true, options: locations?.map(location => ({ label: location.name, value: location.id })), description: `Tell audiences where this event will be held by choosing from the locations you have created.`, error_message: `Please select your event location` },
        { name: 'locationUrl', type: 'url', title: `Please add a link to the access information page for your event`, value: locURL, description: `A link to relevant access information` },
        { name: 'locationName', type: 'text', title: `Please add a name for your touring location`, value: eventData?.locationName, description: `A name for your touring location` },
        { name: 'touringLocation', type: 'locationsearch', title: `Touring location`, value: touringLocationValue, requiredif: 'touring_location' },
        { name: 'type', type: 'multiselect', title: `What type of event is this?`, value: eventData?.type, 'required': true, options: eventTypes, error_message: `Please select the closest option from the list of event types` },
        { name: 'format', type: 'select', title: `What is the format of your event?`, value: formatValue, options: [
                { value: 'InPerson', label: 'In Person' },
                { value: 'Online', label: 'Online' },
                { value: 'Hybrid', label: 'Hybrid' },
                { value: 'Touring', label: 'On Tour' },
            ], description: `Choose an option to indicate whether this event is held in-person, online, or if it is a hybrid event which can be experienced online or in-person.` },
        { name: 'photo1', type: 'file', title: 'Location', value: eventData?.photo1 },
        { name: 'photo2', type: 'file', title: 'Location', value: eventData?.photo2 },
        { name: 'photo3', type: 'file', title: 'Location', value: eventData?.photo3 },
        { name: 'multiloader', type: 'multiloader', description: `You can upload images to appear on your event listing.` },
        { name: 'description', type: 'textarea', title: `Please add a short description about this event.`, value: eventData?.description, 'required': true, description: `This should be a short overview of less than 500 characters.`, error_message: `Please add an event description` },
        { name: 'priceRangeLow', type: 'number', title: `Price range: low`, value: eventData?.priceRangeLow, min: 0.01, step: 1, description: `Please input the lowest ticket price for this event, to give customers an indication of the price range.` },
        { name: 'priceRangeHigh', type: 'number', title: `Price range: high`, value: eventData?.priceRangeHigh, min: 0.01, step: 1, description: `Please input the highest ticket price for this event, to give customers an indication of the price range.` },
        { name: 'defaultBookingLink', type: 'url', title: `Please add the general booking link`, value: eventURL, description: `Enter the web address for your general booking page so that audiences can find out more and buy tickets for your event.` },
        { name: 'instances', type: 'repeater', title: `Event instances`, value: instances, subFields: [
                { name: 'start', type: 'date', title: `Start date`, value: '', required: true, error_message: `Please add a start date` },
                { name: 'start_time', type: 'time', title: `Start time`, value: '', required: true, error_message: `Please add a start time` },
                { name: 'end', type: 'date', title: `End date`, value: '', required: false, showif: 'start' },
                { name: 'end_time', type: 'time', title: `End time`, value: '', showif: 'start', requiredif: 'end' },
                { name: 'bookingLink', type: 'url', title: `Booking link`, value: '', description: `Enter the web address for your booking page for your event so that audiences can find out more and buy tickets.` },
                { name: 'zoneId', type: 'select', title: `Which zone is this held at?`, value: '', description: `Tell audiences where this event will be held by choosing the zone.`, error_message: `Please select a zone` },
                { name: 'provisions', type: 'provisions', title: `What access provisions are available on this instance of the event?`, provisions: allProvisions },
                { name: 'instance_id', type: 'hidden', title: '', value: '' }
            ], description: `Here, you will input information such as date and time of your event and available access provisions. If this event takes place on multiple times/dates, you can add these instances individually.` },
        { name: 'status', 'type': 'select', 'title': `Status`, 'value': eventData?.status || 'Draft', 'required': true, 'options': [{ label: `Draft`, value: 'Draft' }, { label: `Published`, value: 'Published' }], description: `If you are ready to publish your event so that audiences can find out more, change the status from draft to published and press submit.` },
    ];
    return returnEventData;
};
const processProvisionData = (provisionData) => {
    provisionData = Object.entries(provisionData);
    provisionData = provisionData?.map((provision) => {
        provision = provision[1];
        provision.provisions = provision.provisions.map((item) => {
            if (item.hasOwnProperty('provision_data')) {
                return {
                    name: item.standard?.name,
                    id: item.standard?.id,
                    image: item.provision_data.photo?.publicUrl,
                    alt: item.provision_data.photo?.altText,
                    description: item.provision_data?.description,
                    draft: item.provision_data?.draft,
                };
            }
            else {
                return {
                    name: item.name,
                    id: item.id,
                    image: item.image,
                    alt: item.alt,
                    description: item.description,
                    draft: item.draft,
                };
            }
        });
        return provision;
    });
    return provisionData;
};
const formatDateString = (date, longFormat = false, includeTime = true) => {
    if (!date)
        return '';
    let dateObj = new Date(date);
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    if (longFormat) {
        let year = '';
        let minutes = '';
        let hours = dateObj.getUTCHours();
        let ampm = 'am';
        if (hours >= 12) {
            ampm = 'pm';
        }
        hours = hours % 12;
        hours = hours ? hours : 12;
        if (new Date().getUTCFullYear() !== dateObj.getUTCFullYear()) {
            year = ` ${dateObj.getUTCFullYear()}`;
        }
        let timestr = '';
        if (includeTime) {
            if (dateObj.getUTCMinutes() !== 0) {
                minutes = `:${dateObj.getUTCMinutes().toString().padStart(2, '0')}`;
            }
            timestr = hours + minutes + ampm;
        }
        return [`${days[dateObj.getUTCDay()]}, ${dateObj.getUTCDate()} ${months[dateObj.getUTCMonth()]}${year}`, timestr];
    }
    if (!includeTime) {
        return `${dateObj.getUTCDate()} ${months[dateObj.getUTCMonth()]} ${dateObj.getUTCFullYear()}`;
    }
    return `${dateObj.getUTCDate()} ${months[dateObj.getUTCMonth()]} ${dateObj.getUTCFullYear()}, ${dateObj.getUTCHours().toString()}:${dateObj.getUTCMinutes().toString().padStart(2, '0')}`;
};
const dateToMaybeRange = (open, close, longFormat = true) => {
    //console.log({open, close, longFormat});
    const parseDate = (dateStr) => {
        return new Date(dateStr);
    };
    // Helper function to format date according to the specified format
    const formatDate = (date, format) => {
        const options = {
            weekday: format.includes('D') ? 'short' : undefined,
            day: format.includes('j') ? 'numeric' : (format.includes('d') ? '2-digit' : undefined),
            month: format.includes('F') ? 'long' : (format.includes('m') ? '2-digit' : undefined),
            year: format.includes('Y') ? 'numeric' : undefined
        };
        // Remove undefined properties
        Object.keys(options).forEach(key => options[key] === undefined && delete options[key]);
        if (format === 'd') {
            return date.getUTCDate().toString().padStart(2, '0');
        }
        if (format === 'd/m') {
            return `${date.getUTCDate().toString().padStart(2, '0')}/${(date.getUTCMonth() + 1).toString().padStart(2, '0')}`;
        }
        if (format === 'm/Y') {
            return `${(date.getUTCMonth() + 1).toString().padStart(2, '0')}/${date.getUTCFullYear()}`;
        }
        if (format === 'Y') {
            return date.getUTCFullYear().toString();
        }
        if (format === 'm') {
            return (date.getUTCMonth() + 1).toString().padStart(2, '0');
        }
        if (format === 'd/m/Y') {
            return `${date.getUTCDate().toString().padStart(2, '0')}/${(date.getUTCMonth() + 1).toString().padStart(2, '0')}/${date.getUTCFullYear()}`;
        }
        if (format === 'j') {
            return `${date.getUTCDate()}`;
        }
        if (format === 'j F') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
            return `${date.getUTCDate()} ${months[date.getUTCMonth()]}`;
        }
        if (format === 'F Y') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
            return `${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
        }
        if (format === 'F') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
            return months[date.getUTCMonth()];
        }
        if (format === 'j F Y') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
            return `${date.getUTCDate()} ${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
        }
        return date.toLocaleDateString();
    };
    // Define format strings based on longFormat parameter
    let day, dayMonth, monthYear, year, month, dayMonthYear;
    if (longFormat) {
        day = "j";
        dayMonth = "j F";
        monthYear = "F Y";
        year = "Y";
        month = "F";
        dayMonthYear = "j F Y";
    }
    else {
        day = "d";
        dayMonth = "d/m";
        monthYear = "m/Y";
        year = "Y";
        month = "m";
        dayMonthYear = "d/m/Y";
    }
    // If no close date or dates are the same, return single date
    let closeNoTime = close ? close.split('T')[0] : null;
    let openNoTime = open ? open.split('T')[0] : null;
    if (!close || openNoTime === closeNoTime) {
        return formatDate(parseDate(open), dayMonthYear);
    }
    const openDate = parseDate(open);
    const closeDate = parseDate(close);
    const eventStartMonth = openDate.getMonth();
    const eventEndMonth = closeDate.getMonth();
    const eventStartYear = openDate.getFullYear();
    const eventEndYear = closeDate.getFullYear();
    // Same month and year - show day range
    if (eventStartMonth === eventEndMonth && eventStartYear === eventEndYear) {
        return formatDate(openDate, day) + " - " + formatDate(closeDate, dayMonthYear);
    }
    // Same year - show month range
    else if (eventStartYear === eventEndYear) {
        return formatDate(openDate, dayMonth) + " - " + formatDate(closeDate, dayMonthYear);
    }
    // Different years - show full date range
    else {
        return formatDate(openDate, dayMonthYear) + " - " + formatDate(closeDate, dayMonthYear);
    }
};
const currencyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    trailingZeroDisplay: 'stripIfInteger'
});
export { eventTypes, processEventData, processProvisionData, formatDateString, dateToMaybeRange, currencyFormatter };
